'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/minuteFromNow.js
// module id = 186
// module chunks = 0